import type { JSX } from 'react';

export function EventDetailsEditNotice(): JSX.Element {
    return (
        <div className="bg-muted/50 rounded-lg p-3">
            <p className="text-muted-foreground text-xs">
                To edit event details, please make changes directly in your calendar application.
            </p>
        </div>
    );
}
